import { Link } from 'react-router-dom';

const footerLinks = {
  快速导航: [
    { label: '首页', path: '/' },
    { label: '游戏分类', path: '/category/all' },
    { label: '游戏攻略', path: '/article/guide-intro' },
    { label: '关于我们', path: '/about' },
  ],
  游戏分类: [
    { label: '休闲益智', path: '/category/casual' },
    { label: '角色扮演', path: '/category/rpg' },
    { label: '策略竞技', path: '/category/strategy' },
    { label: '棋牌游戏', path: '/category/board' },
    { label: '体育竞速', path: '/category/sports' },
  ],
  帮助支持: [
    { label: '下载教程', path: '/article/download-guide' },
    { label: '常见问题', path: '/article/faq' },
    { label: '账号安全', path: '/article/account-security' },
    { label: '用户协议', path: '/article/terms' },
    { label: '隐私政策', path: '/article/privacy' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50/80">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <span className="font-heading text-2xl text-accent-400">NG南宫</span>
            <p className="mt-3 text-sm text-foreground-100/60 leading-relaxed">
              NG南宫官方正版APP下载平台，提供最新版本iOS/Android安装包，安全无病毒，一键下载即玩，为您带来极致的游戏体验。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800/50 hover:bg-accent-500 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800/50 hover:bg-accent-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800/50 hover:bg-accent-500 transition-colors cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line text-sm"></i>
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-heading text-base text-background-50 mb-4">{title}</h4>
              <ul className="flex flex-col gap-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-100/60 hover:text-accent-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-foreground-800/40 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-100/50">
            &copy; {new Date().getFullYear()} NG南宫 版权所有 | 本站所有内容仅供游戏交流参考
          </p>
          <p className="text-xs text-foreground-100/50">
            <Link to="/article/terms" className="hover:text-accent-400 transition-colors cursor-pointer">用户协议</Link>
            <span className="mx-2">|</span>
            <Link to="/article/privacy" className="hover:text-accent-400 transition-colors cursor-pointer">隐私政策</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}